export default __webpack_public_path__ + "static/media/tick.3a9ee341.svg";